import { AspectRatio, ReadMore } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import AddIcon from '@mui/icons-material/Add';

interface Props {
  viewProductCard: () => void;
  viewCalculusCard?: () => void;
  addToAssortment?: () => void;
}
export const AssortmentItemActions = ({
  viewProductCard,
  viewCalculusCard,
  addToAssortment,
}: Props) => {
  const t = useMyAssortmentTFunction();

  return (
    <>
      {!!addToAssortment && (
        <Tooltip title={t('myAssortment.actions.addToOwnAssortment')}>
          <IconButton onClick={() => addToAssortment()}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title={t('myAssortment.actions.seeProductInfo')}>
        <IconButton onClick={viewProductCard} sx={{ p: 0 }}>
          <AspectRatio fontSize="small" />
        </IconButton>
      </Tooltip>

      {viewCalculusCard && (
        <Tooltip title={t('myAssortment.actions.seeCalculusCard')}>
          <IconButton onClick={viewCalculusCard}>
            <ReadMore />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};
